import { useMutation, useQueryClient } from "@tanstack/react-query";
import { termsApi } from "../api/termsApi";

// O backend devolve o usuário já atualizado: grava direto no cache de /me para o modal
// fechar na hora, sem esperar o refetch.
export function useAcceptTermsMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: termsApi.accept,
    onSuccess: (user) => {
      queryClient.setQueryData(["auth", "me"], (me) => (me ? { ...me, user } : me));
      queryClient.invalidateQueries({ queryKey: ["auth", "me"] });
    },
  });
}
